import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [{ path: '/close-period', component: FuseLoadable({ loader: () => import('./ClosePeriodApp') }) }],
};

export default [Index];
